import { Component, OnInit } from '@angular/core';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';
@Component({
  selector: 'fgb-contact-us-page',
  templateUrl: './contact-us-page.component.html',
  styleUrls: ['./contact-us-page.component.scss'],
})
export class ContactUsPageComponent implements OnInit {
  
  constructor(
    private navigationService: NavigationService
  ) {}

  ngOnInit() {
    this.navigationService.hideMobileNav();
  }
  ngOnDestroy(): void {
    this.navigationService.showMobileNav();
  }
}
